import { useFlow } from '@stackflow/react';
import { useEffect } from 'react';

function usePermission() {
    const { push } = useFlow();
    useEffect(() => {
        if (localStorage.getItem('permissionAsked') !== 'true') {
            push('PermissionBottomSheet', {});
        }
    }, []);
}

export default usePermission;
